package com.appcreator.compose.envfunctions

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import coil3.PlatformContext
import coil3.compose.LocalPlatformContext
import com.appcreator.blueprint.core.EnvFunction
import com.appcreator.compose.BlueprintConfig
import kotlin.time.Clock
import kotlin.time.Instant
import kotlinx.datetime.TimeZone
import kotlinx.datetime.offsetAt


// This is a slap dash un-documents feature
@Composable
fun rememberEnvFunctions(config: BlueprintConfig): Map<String, EnvFunction> {
    val context = LocalPlatformContext.current
    return remember {
        mapOf(
            "now()" to EnvFunction { _, staticPass -> if(staticPass) "now" else Instant.fromEpochSeconds(Clock.System.now().epochSeconds).toString() },
            "appVersion()" to EnvFunction { _, _ -> appVersion(context) },
            "appBuildNumber()" to EnvFunction { _, _ -> appBuildNumber(context) },
            "deviceName()" to EnvFunction { _, _ -> deviceName() },
            "deviceVersion()" to EnvFunction { _, _ -> deviceVersion() },
            "platformName()" to EnvFunction { _, _ -> platformName() },
            "appStoreUrl()" to EnvFunction { _, _ -> appStoreUrl(context, config) },
            "timezone()" to EnvFunction { _, _ -> TimeZone.currentSystemDefault().id },
            "timezoneOffset()" to EnvFunction { _, _ -> TimeZone.currentSystemDefault().offsetAt(Clock.System.now()).toString() }
        )
    }
}

expect fun platformName(): String
expect fun appVersion(platform: PlatformContext): String
expect fun appBuildNumber(platform: PlatformContext): String
expect fun deviceName(): String
expect fun deviceVersion(): String
expect fun appStoreUrl(platform: PlatformContext, config: BlueprintConfig): String